export class Material {
  constructor(
    public ATC: number,
    public ATRIBUTOS: string,
    public BASE: string,
    public CARACTERISTICAS: string,
    public CMP1: string,
    public CMP2: string,
    public CMP3: string,
    public CMP4: string,
    public CMP5: string,
    public CMP6: string,
    public CODIGO_COR: string,
    public CODIGO_PANTONE: string,
    public COLECAO: string,
    public COMP1_BRA_FT1: string,
    public COMP1_CJ_FT1: string,
    public COMP2_BRA_FT1: string,
    public COMP2_CJ_FT1: string,
    public COMP3_BRA_FT1: string,
    public COMP3_CJ_FT1: string,
    public COMP4_BRA_FT1: string,
    public COMP4_CJ_FT1: string,
    public COMP5_BRA_FT1: string,
    public COMP5_CJ_FT1: string,
    public COMP6_BRA_FT1: string,
    public COMP6_CJ_FT1: string,
    public COMPRIMENTO_RAP: string,
    public DATA_ATC: string,
    public DATA_PE: string,
    public DESENHO: string,
    public EBOOK_CODE: string,
    public EBOOK_PAGE: string,
    public ETIQUETA: string,
    public GRAMATURA_M: string,
    public GRAMATURA_ML: string,
    public GRUPO: string,
    public GRUPO_CORES: string,
    public LARGURA_RAP: string,
    public LARGURA_TOTAL: number,
    public LARGURA_UTIL: number,
    public MAKTX: string,
    public MANDT: string,
    public MATNR: string,
    public MEDIA_PECA: number,
    public MOTIVO_DETALHE: string,
    public MOTIVO_PADRAO: string,
    public ONCAS: string,
    public PE: number,
    public PERCENT1: number,
    public PERCENT1_BRA_FT1: number,
    public PERCENT1_CJ_FT1: number,
    public PERCENT2: number,
    public PERCENT2_BRA_FT1: number,
    public PERCENT2_CJ_FT1: number,
    public PERCENT3: number,
    public PERCENT3_BRA_FT1: number,
    public PERCENT3_CJ_FT1: number,
    public PERCENT4: number,
    public PERCENT4_BRA_FT1: number,
    public PERCENT4_CJ_FT1: number,
    public PERCENT5: number,
    public PERCENT5_BRA_FT1: number,
    public PERCENT5_CJ_FT1: number,
    public PERCENT6: number,
    public PERCENT6_BRA_FT1: number,
    public PERCENT6_CJ_FT1: number,
    public RENDIMENTO: string,
    public SGRUPO: string,
    public TECIMENTO: string,
    public UNIDADE_MEDIDA: string,
    public UTILIZACAO: string
  ) { }
}
